import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/uk.awbridal.com/html/src/components/Craftsmanship/craftsmanship.js");
